import type { FaireProductEntity } from "../../entity_types/product";

export const p_axqf8g54n3: FaireProductEntity = {
  token: "p_axqf8g54n3",
  type: "product",
  name: "Foamy Lips & Skulls Swedish Candy Bag 2.8oz",
  brandToken: "b_4ecnlfrq9x",
  brandName: "Sockerbit",
  imageUrl:
    "https://cdn.faire.com/fastly/5f783bc00a5c80256a95054e4437fa245a62b2b9310994149f0081aa7fc0a4bb.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5e02e3c316c00eff90a3ac45f37e4a580edd74da83f2cfdd5f860735a7e00e94.jpeg",
    "https://cdn.faire.com/fastly/2ce8ffaf2ce182894d41a92caa86b5f83bbc4b32603a591f737dc43d23d50e35.jpeg",
  ],
  priceDollars: 2.5,
  description:
    "Sour, foamy, and irresistibly balanced - our Foamy Lips & Skulls combine a light, foamy bite with natural raspberry, strawberry & forest fruits flavors.\n\nProduct of the EU, made with quality, non-GMO ingredients and free from high fructose corn syrup and trans fats.\n\nJOY IS AN ESSENTIAL NUTRIENT",
  tags: [],
  msrpDollars: 5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:53:34.895Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
